import React, { forwardRef } from 'react';

import { Chip } from '../Chip';
import * as s from './TagScrolling.css';
import { ITagScrollingParams } from './types';

/** Панель прокрутки тэгов */
export const TagScrolling = forwardRef<HTMLDivElement, ITagScrollingParams>(
  ({ items, activeTagId, size, onClick }, ref) => {
    if (!items?.length) {
      return null;
    }

    return (
      <div className={`${s['wrapper']}`} ref={ref}>
        <div className={`${s['inner-wrapper']}`}>
          {items.map(item => (
            <Chip
              key={`tag-${item.id}`}
              isActive={activeTagId === item.id}
              size={size}
              theme="stroke_secondary"
              onClick={() => onClick(item.name)}
            >
              #{item.name}
            </Chip>
          ))}
        </div>
      </div>
    );
  },
);

TagScrolling.displayName = 'TagScrolling';
